var Codec = require('io/codec');
var serialiser = require('schema/serialiser');
var BEES = require('serialisers/byte-encoded-enum-serialiser');
var TopicType = require('../../../topics/topics').TopicType;

/**
 * Serialise topic details - in practical terms this accepts a metadata instance
 * and writes necessary topic detail values around it.
 */
module.exports = {
    read : function(input) {
        var details = {};

        if (Codec.readBoolean(input)) {
            details.type = BEES.read(input, TopicType);

            if (Codec.readBoolean(input)) {
                details.schema = serialiser.read(input);
            }
        }

        return details;
    },
    write : function(output, details) {
        if (details) {
            Codec.writeBoolean(output, true);

            BEES.write(output, details.type);

            if (details.schema) {
                Codec.writeBoolean(output, true);
                serialiser.write(output, details.schema);
            }

            // No attributes - use server defaults
            Codec.writeBoolean(output, false);
        } else {
            // No details
            Codec.writeBoolean(output, false);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/topics/details/topic-details-serialiser.js
// module id = 324
// module chunks = 0